module.exports = __webpack_public_path__ + "static/media/Zinc-Screenshot-3.3fd64041.png";